const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org-id/$orgId/$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org-id/$orgId/$')({
  beforeLoad: ({
    context,
    params,
    location
  }) => {
    const {
      organizationId,
      organizationName
    } = context;
    const remainingPath = params._splat ?? '';
    if (params.orgId === organizationId && organizationName) {
      const searchAndHash = `${location.searchStr ?? ''}${location.hash ? `#${location.hash}` : ''}`;
      throw redirect({
        href: `/org/${organizationName}/${remainingPath}${searchAndHash}`,
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});